import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { logError } from './lib/logger';

// Global Error Listeners
window.addEventListener('error', (event) => {
    logError(event.error || event.message, { 
        componentName: 'Global', 
        errorType: 'frontend-runtime',
        showToast: false
    });
});

window.addEventListener('unhandledrejection', (event) => {
    logError(event.reason, { 
        componentName: 'GlobalPromise', 
        errorType: 'unhandled-rejection',
        showToast: false
    });
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
